import {
  failureAction, successAction, startAction,
} from '../../common'
import {
  SAVE_TOURNAMENT, RESET_SAVE_TOURNAMENT, SAVE_TOURNAMENT_DESCRIPTION, SAVE_TOURNAMENT_SETTINGS,
} from '../types'

export const initialState = {
  saving: false,
  saved: false,
  error: {},
  data: {},
}

const reducer = ({ edit: state }, action) => {
  switch (action.type) {
    case startAction(SAVE_TOURNAMENT):
    case startAction(SAVE_TOURNAMENT_DESCRIPTION):
    case startAction(SAVE_TOURNAMENT_SETTINGS):
      return {
        ...state,
        saving: true,
        saved: false,
        error: {},
        data: {},
      }
    case successAction(SAVE_TOURNAMENT):
    case successAction(SAVE_TOURNAMENT_DESCRIPTION):
    case successAction(SAVE_TOURNAMENT_SETTINGS):
      return {
        ...state,
        saving: false,
        saved: true,
        error: {},
        data: action.payload,
      }
    case failureAction(SAVE_TOURNAMENT):
    case failureAction(SAVE_TOURNAMENT_DESCRIPTION):
    case failureAction(SAVE_TOURNAMENT_SETTINGS):
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload,
        data: {},
      }

    case RESET_SAVE_TOURNAMENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducer
